import { Box, Button, Card, CardContent, Tab, Tabs, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types';
import { getEOCActive } from '../../reducer/eocActiveSlice';
import dayjs from "dayjs";
import { useSelector } from 'react-redux';
import TabDetail from './TabOpenEOC/TabDetail';
import TabActivity from './TabOpenEOC/TabActivity';
import { getProfile } from '../../reducer/profileSlice';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import { getActivityActive } from '../../reducer/activityActiveSlice';
import EOCClose from './EOCManage/EOCClose';
import EOCEdit from './EOCManage/EOCEdit';
import EOCCancel from './EOCManage/EOCCancel';

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box>{children}</Box>}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function CustomOpenEOC({ handleSuccess }) {

    const [value, setValue] = useState(0);
    const eocActive = useSelector(getEOCActive);
    const profile = useSelector(getProfile);
    const activityActive = useSelector(getActivityActive);
    const [modalOpenCloseEOC, setmodalOpenCloseEOC] = useState(false);
    const [modalOpenEditEOC, setmodalOpenEditEOC] = useState(false);
    const [modalOpenCancelEOC, setmodalOpenCancelEOC] = useState(false);
    const [enableEOCClose, setEnableEOCClose] = useState(false);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const startEOC = () => {
        const timeStamp = eocActive?.start_eoc_timestamp;
        const date = new Date(parseInt(timeStamp));
        let startEOCDate = dayjs(date).locale("th").format("DD MMMM YYYY");
        return startEOCDate;
    };

    const showDuration = () => {
        let timeUsed = "";
        const eocCreateTime = dayjs(parseInt(eocActive?.start_eoc_timestamp));
        const nowDate = dayjs().startOf('day');
        timeUsed = nowDate.diff(eocCreateTime, 'day');
        if (timeUsed === 0) {
            return "เปิด EOC วันนี้"
        } else if (timeUsed < 0) {
            return "จะเปิด EOC ในอีก " + timeUsed * -1 + " วัน"
        }
        return "ระยะเวลาที่เปิด EOC " + timeUsed + " วัน"
    }

    const getEOCDataTitle = () => {
        let data = {
            org_level: "EOC ระดับ",
            org_name: "",
            org_name_title: "",
        };
        if (eocActive?.org_level === "01") {
            data.org_level += "ประเทศ";
            data.org_name += eocActive?.org_name;
            data.org_name_title += "ประเทศ";
        } else if (eocActive?.org_level === "02") {
            data.org_level += "เขต";
            data.org_name += eocActive?.org_name;
            data.org_name_title += "เขต";
        } else if (eocActive?.org_level === "03") {
            data.org_level += "จังหวัด";
            data.org_name += eocActive?.province_name;
            data.org_name_title += "จังหวัด";
        } else if (eocActive?.org_level === "04") {
            data.org_level += "อำเภอ";
            data.org_name += eocActive?.amphur_name + " " + eocActive?.province_name;
            data.org_name_title += "อำเภอ";
        }
        return data;
    };

    useEffect(() => { // ปรับเพิ่มเติมเช็กการเปิด/ปิด ปุ่มปิด EOC
        const checkEOCClose = () => {
            let timeUsed = "";
            const eocCreateTime = dayjs(parseInt(eocActive?.start_eoc_timestamp));
            const nowDate = dayjs().startOf('day');
            timeUsed = nowDate.diff(eocCreateTime, 'day');
            if (timeUsed === 0) {
                setEnableEOCClose(true);
            } else if (timeUsed < 0) {
                setEnableEOCClose(false);
            } else {
                setEnableEOCClose(true);
            }
        };
        if (eocActive) {
            checkEOCClose();
        }
    }, [eocActive])

    return (
        <div>
            <Typography variant="h6">
                อยู่ระหว่างเปิดศูนย์ปฏิบัติการณ์ตอบโต้ภาวะฉุกเฉินด้านสาธารณสุข (EOC)
            </Typography>
            <div className='flex flex-col md:flex-row justify-between mt-4 mb-2 gap-4'>
                <div>
                    <Typography
                        sx={{ color: "#D48061" }}
                        variant="body2"
                    >
                        วันที่เปิด EOC
                    </Typography>
                    <Typography>{startEOC()}</Typography>
                </div>
                {((profile?.org_id === eocActive?.org_id) || (profile?.org_level === "01")) && (
                    <div className='grid grid-flow-col gap-4'>
                        {enableEOCClose && (
                            <Button
                                variant="contained"
                                className='bg-[#cd6c4a] hover:bg-[#cd6c4a] md:w-28 h-9'
                                onClick={() => setmodalOpenCloseEOC(true)}
                            >ปิด EOC</Button>
                        )}
                        <Button
                            variant="outlined"
                            className='md:w-24 h-9'
                            color='warning'
                            onClick={() => setmodalOpenEditEOC(true)}
                        >แก้ไข</Button>
                        <Button
                            variant="outlined"
                            className='md:w-24 h-9'
                            color='inherit'
                            onClick={() => setmodalOpenCancelEOC(true)}
                        >ยกเลิก</Button>
                    </div>
                )}
            </div>

            <Card className='border border-gray-300 rounded bg-gradient-to-b from-0% from-orange-50 to-30% to-transparent'>
                <CardContent>
                    <Box sx={{ width: '100%' }}>
                        <Box sx={{
                            borderBottom: 1,
                            borderColor: 'divider',
                            display: 'flex',
                            justifyContent: 'space-between', // จัด tab ไปทางซ้าย และ label ไปทางขวา
                            alignItems: 'center', // จัดให้ทั้งสองฝั่งอยู่ในแนวเดียวกัน
                        }}>
                            <Tabs
                                value={value}
                                onChange={handleChange}
                                aria-label="basic tabs example"
                                textColor="inherit"
                                TabIndicatorProps={{
                                    style: {
                                        backgroundColor: 'rgb(205,108,74)',
                                    },
                                }}
                            >
                                <Tab label={<Typography variant="body1">รายละเอียด</Typography>} {...a11yProps(0)} />
                                <Tab label={<Typography variant="body1">กิจกรรม</Typography>} {...a11yProps(1)} disabled={!enableEOCClose} />
                            </Tabs>
                            <div className='hidden sm:flex gap-1 items-center justify-center text-gray-800'>
                                <TimerOutlinedIcon sx={{width: 18}}/>
                                <Typography variant="body2">{showDuration()} </Typography>
                            </div>
                        </Box>
                        <CustomTabPanel value={value} index={0} className="px-0 pt-4 md:px-2">
                            <TabDetail />
                        </CustomTabPanel>
                        <CustomTabPanel value={value} index={1} className="px-0 pt-4 md:px-2">
                            <TabActivity />
                        </CustomTabPanel>
                    </Box>
                </CardContent>
            </Card>

            <EOCClose
                open={modalOpenCloseEOC}
                onClose={() => setmodalOpenCloseEOC(false)}
                data={activityActive}
                dataTitle={getEOCDataTitle()}
                onSuccess={() => {
                    handleSuccess();
                }}
            />
            <EOCEdit
                open={modalOpenEditEOC}
                onClose={() => setmodalOpenEditEOC(false)}
                dataTitle={getEOCDataTitle()}
                onSuccess={() => {
                    handleSuccess();
                }}
            />
            <EOCCancel
                open={modalOpenCancelEOC}
                onClose={() => setmodalOpenCancelEOC(false)}
                dataTitle={getEOCDataTitle()}
                onSuccess={() => {
                    handleSuccess();
                }}
            />
        </div>
    )
}

export default CustomOpenEOC